import LotteryV2Step from "./LotteryV2Step";
import { CatcherConfig } from "./CatcherConfig";

export const LotteryType = {
  Wheel: "Wheel",
  Facebook: "Facebook",
  Instagram: "Instagram",
  GoogleRating: "GoogleRating",
  Snapchat: "Snapchat",
  Quizz: "Quizz",
  ScratchCardChristmas: "ScratchCardChristmas",
  ScratchCard: "ScratchCard",
  AdventCalendar: "AdventCalendar",
  Tombola: "Tombola",
  SlotMachine: "SlotMachine",
  GiftMachine: "GiftMachine",
  Catcher: "Catcher",
};

export interface WheelItem {
  index: number;
  label: string;
  longDesc: string;
  preserveCase: boolean;
  isLost?: boolean;
  isGC?: boolean;
  id: string;
}

export default interface LotteryConfigurationResponse {
  type?: string;
  wheelItems?: WheelItem[];
  facebookPageId?: string;
  instagramProfileId?: string;
  snapchatProfileId?: string;
  googlePlaceId?: string;
  steps?: LotteryV2Step[] | undefined | null;

  venueId?: string;

  hideCTA?: boolean;
  giftIsForNextTime?: boolean;

  hasSpecificConditions?: boolean;
  specificConditions?: string;

  customizeColors?: boolean;

  colBodyBack?: string;
  colBodyFont?: string;
  colModalFont?: string;
  colHighlight?: string;
  colFooterFont?: string;
  colFooterBack?: string;
  colCTAFont?: string;
  colCTABack?: string;
  colCTADisabledFont?: string;
  colCTADisabledBack?: string;
  colLoader?: string;
  colWheelBack?: string;
  colWheelFront?: string;

  colWheel1Back?: string;
  colWheel1Front?: string;

  colWheel2Back?: string;
  colWheel2Front?: string;

  colV2Sector1BG?: string;
  colV2Sector1FG?: string;
  colV2Sector2BG?: string;
  colV2Sector2FG?: string;
  colV2Sector3BG?: string;
  colV2Sector3FG?: string;
  colV2Sector4BG?: string;
  colV2Sector4FG?: string;

  colV2WheelText?: string;

  colV2WheelStructFill?: string;
  colV2WheelStructFill2?: string;
  colV2WheelStructTop?: string;
  colV2WheelStructLines?: string;

  colV2ShadowColor?: string;
  colV2CursorColor?: string;
  colV2CursorShadowColor?: string;

  colV2PL?: string;
  colV2P?: string;
  colV2PD?: string;

  colV2SL?: string;
  colV2S?: string;
  colV2SD?: string;

  v2Gift1ColorIdx?: number;
  v2Gift2ColorIdx?: number;
  v2Balloon1ColorIdx?: number;
  v2Balloon2ColorIdx?: number;

  colV2Stars?: string;

  colHeader?: string;

  v2FoliageColor1?: string;
  v2FoliageColor2?: string;
  v2FoliageColor3?: string;

  v2HideStars?: boolean;
  v2HideBalloon?: boolean;
  v2HideGifts?: boolean;

  logoHeight?: number;
  logoURL?: string;

  replayInterval?: number;

  qQuestionsPerGame?: number;
  qWinScore?: number;
  qTimerSeconds?: number;

  qIntroText?: string;
  qIntroSubText?: string;
  qIntroFooterText?: string;

  hideAddressOnCoupons?: boolean;
  isEcommerce?: boolean;
  disableBlinking?: boolean;

  voucherWording?: string;
  hideOfferToFriend?: boolean;

  askWinnersForOptin?: boolean;
  askWinnersForPhoneNumber?: boolean;

  taCTAOnCoupon?: string;

  isDisabled?: boolean;
  customSuspensionText?: string;

  scBG?: string;
  scFG?: string;
  scImg?: string;
  scImgH?: number;
  scImgW?: number;
  scThreshold?: number;
  scTop?: number;
  scLeft?: number;
  scText?: string;
  scTitle?: string;
  colLogoBg?: string;

  site?: string;
  sc1?: boolean;

  rulesURL?: string;

  desktop?: boolean;
  bgURL?: string;
  lostText?: string;

  ctaOnCoupon?: boolean;
  ctaURL?: string;
  ctaText?: string;

  colSidesDesktop?: string;

  smW?: number;
  smH?: number;
  smIH?: number;
  smUrl?: string;
  smNItems?: number;

  smsAuthInterval?: number;

  optinTxt?: string;
  customLinkImg?: string;

  customWinImg?: string;
  customWinTxt?: string;

  taPopupInRedeem?: string;
  tripAdvisorLink?: string;

  mustSign?: boolean;
  redeemByQRCode?: boolean;

  gdprLegalNotice?: string;
  displayContactFormOnHelp?: boolean;
  disableCentering?: boolean;
  youNeedASmartphoneText?: string;
  overrideIGVenueName?: string;
  overrideFBVenueName?: string;

  blockedTitle?: string;
  blockedText?: string;

  hasML?: boolean;

  hideOptin?: boolean;
  useOptin?: boolean;
  wheelDegInitial?: number;

  mlSuffix?: string;
  mlToken?: string;
  mlTokenW?: number;
  mlTokenH?: number;

  customMLGameTitle?: string;
  customMLGameText?: string;
  customMLTokenNameSingular?: string;
  customMLTokenNamePlural?: string;

  customSponsoreeCTAText?: string;
  disabledRedirURL?: string;

  phoneOptinInML?: boolean;
  sponsorshipText?: string;
  customSuspensionTitle?: string;

  catcher?: CatcherConfig;
}
